<template>
  <div class="employee-schedule-data d-flex ">
    <v-form ref="formRef" @submit.prevent="updateSchedules">
      <ScheduleManager :show-title="false" :show-presets="true" :show-bulk-actions="true" :show-summary="true"
        :show-submit-button="false" :initial-schedule="props.schedules" @change="onScheduleChange" :horizontal-layout="true" />
      <v-card-actions class="d-flex justify-end pa-4">
        <span class="w-md-25">
          <ButtonHoverGradient :label="t('common.save')" :action="updateSchedules" />
        </span>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script lang="ts" setup>
import type { ScheduleInterface } from '~/interfaces/scheduleInterface'
import { useEmployeesComposable } from '~/composables/api/employee'
import ButtonHoverGradient from '../common/ButtonHoverGradient.vue'
import ScheduleManager from '../schedules/ScheduleManager.vue'

interface Props {
  modelValue: boolean
  companyUuid: string
  schedules: ScheduleInterface[]
  employeeUuid?: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'schedules-updated': [schedules: ScheduleInterface[]]
  'save-success': [message: string]
  'save-error': [error: string]
}>()


const { t } = useI18n()
const { createEmployeeSchedule } = useEmployeesComposable()

const saving = ref(false)
const currentSchedules = ref<ScheduleInterface[]>([])

const onScheduleChange = (schedules: ScheduleInterface[]) => {
  currentSchedules.value = schedules
}

const updateSchedules = async () => {
  saving.value = true
  try {
    if (props.employeeUuid) {
      const result = await createEmployeeSchedule(
        props.companyUuid,
        props.employeeUuid,
        currentSchedules.value
      ) as { error?: unknown }

      if (result.error) {
        emit('save-error', t('employees.scheduleUpdateError'))
      } else {
        emit('schedules-updated', currentSchedules.value)
        emit('save-success', t('employees.scheduleUpdated'))
      }
    } else {
      emit('save-error', t('employees.noEmployeeUuid'))
    }
  } catch {
    emit('save-error', t('employees.scheduleUpdateError'))
  } finally {
    saving.value = false
  }
}
</script>